
// [프론트엔드 라우팅 분기 전략 메모 - 서브도메인 전략]
//
// 1. 서버(또는 CDN, 호스팅) 준비
//    - bearbrick.gameking.com 등 원하는 서브도메인을 DNS에서 React 앱이 배포된 서버로 연결해야 함
//      (A레코드, CNAME 등)
//    - 해당 도메인으로 들어온 모든 경로 요청이 React 앱의 index.html(및 정적 리소스)로 서빙되도록 서버 설정 필요
//      (nginx: try_files $uri /index.html, S3+CloudFront: SPA 리디렉션, Apache: mod_rewrite 등)
//    - 즉, mgp.gameking.com과 bearbrick.gameking.com 모두 같은 React 빌드 결과물을 서빙해야 함
//
// 2. 프론트엔드(React SPA) 분기 전략
//    - window.location.hostname을 체크하여 도메인별로 UI/기능/라우팅을 분기
//    - 예) bearbrick.gameking.com에서 접근 시 내부적으로 /GamePage/ 이하로 라우팅하거나,
//         gameSvcCd=brbr 등 props/search를 강제 주입
//    - 주소창 도메인은 그대로 두고, 실제 렌더링/동작만 mgp.gameking.com의 특정 페이지와 동일하게 맞출 수 있음
//    - 이 방식은 서버 리다이렉트/프록시 없이 SPA에서 도메인별 UI/기능 분기할 때 사용
//
// 3. 주의사항
//    - 프론트엔드만으로는 도메인 생성/연결이 불가하며, 반드시 서버에서 해당 도메인에 React 앱이 배포되어 있어야 함
//    - 서버 준비가 안 되어 있으면 bearbrick.gameking.com으로 접속 자체가 불가함
//    - 서버가 준비된 후에야 window.location.hostname 분기 로직이 의미가 있음
//
// 4. React Router Link 제한사항
//    - <Link to="/">는 현재 도메인 내에서만 작동 (bearbrick.com에서 클릭 시 bearbrick.com/로 이동)
//    - 다른 도메인으로 이동 시 반드시 풀 URL 사용:
//      • <a href="https://mgp.gameking.com/login">로그인</a>
//      • onClick={() => window.location.href = "https://mgp.gameking.com/terms"}
//    - 도메인 간 이동 시 페이지 새로고침 발생 (SPA 장점 상실)
//
// 5. 실전 구현 전략
//    - 공통 기능(회원가입, 로그인, 약관, 회사소개 등)은 mgp.gameking.com에서만 처리
//    - 게임별 서브도메인에서는 해당 게임 컨텐츠만 제공
//    - 푸터/헤더의 공통 링크는 풀 URL로 하드코딩
//    - 각 서브도메인은 독립 사이트처럼 운영되어 브랜딩/SEO 효과
//
// 6. 장단점 비교
//    [장점]
//    - SEO: 각 게임별 독립 도메인으로 검색 노출 유리
//    - 브랜딩: 게임별 전용 도메인으로 전문성/신뢰도 향상
//    - 명확한 구분: 사용자가 어떤 게임 사이트인지 직관적으로 인식
//    [단점]
//    - Link 제한: React Router의 Link를 도메인 간 사용 불가
//    - 페이지 리로드: 도메인 간 이동 시 SPA 장점 상실
//    - 개발 복잡도: 공통 컴포넌트에서 도메인별 분기 처리 필요
//    - 세션 관리: 도메인 간 로그인 세션 공유 고려 필요
import React, { useEffect ,useState } from 'react';
import { useEffect as useFaviconEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
//Apis
import IsLoginApi from 'Apis/IsLoginApi';
import IsMntnInqApi from 'Apis/IsMntnInqApi';
// 도메인 설정 유틸리티
import { getDomainGameMap, pushToDataLayer } from 'Utils/domainConfig';

//Layouts
import MainLayout from 'Layouts/MainLayout';
import LoginLayout from 'Layouts/LoginLayout';
import PopLayout from 'Layouts/PopLayout';
import LeftMenuLayout from 'Layouts/LeftMenuLayout';

//View
import MainPage from 'Views/MainPage';
import LoginPage from 'Views/Login';
import OtpAthn from 'Views/Login/OtpAthn';
import MembJoinPage from 'Views/MembJoin';
import MembFindIdRsltUi from 'Views/Memb/MembFindIdRsltUi';
import EmlAthnPopUi from 'Utils/EmlAthnPopUi';
import RouteChngTracker from 'Utils/RouteChngTracker';
import MbpAthnCallback from 'Utils/MbpAthnCallback';
import GameLnchStrtUi from 'Views/Login/GameLnchStrtUi';
import MembJoinFormUi from 'Views/MembJoin/MembJoinFormUi';
import MembJoinDoneUi from 'Views/MembJoin/MembJoinDoneUi';
import GameLogin from 'Views/Login/GameLoginUi';
import TrmsLayout from 'Layouts/TrmsLayout';
import TrmsCtxtUi from 'Views/Trms/TrmsCtxtUi';
import CommErrorUi from 'Views/Comm/CommError';
import CommMntnUi from 'Views/Comm/CommMntnUi';
import GamePageMainUi from 'Views/Game';
import PrivateRoute from 'Utils/PrivateRoute';
import MyPage from 'Views/MyPage/main';
import MembFindIdUi from 'Views/Memb/MembFindIdUi';
import MembPasswdChngUi from 'Views/Memb/MembPasswdChngUi';
import MembOtpRegUi from 'Views/MyPage/MembOtpRegUi';
import MembOtpRegInputUi from 'Views/MyPage/MembOtpRegInputUi';
import MembIdntMthdChngUi from 'Views/MyPage/MembIdntMthdChngUi';
import MembEmlChngUi from 'Views/MyPage/MembEmlChngUi';
import MembEmlChngInputUi from 'Views/MyPage/MembEmlChngInputUi';
import MembLvdUi from 'Views/MyPage/MembLvdUi';
import MembGameSvcRelUi from 'Views/MyPage/MembGameSvcRelUi';
import MembNtfyMsgLstUi from 'Views/MyPage/MembNtfyMsgLstUi';
import CtntLstUi from 'Views/MainPage/CtntTop5LstUi';
import CtntPstdLstUi from 'Views/Ctnt/CtntPstdLstUi';
import QnaLstUi from 'Views/Cs/QnaLstUi';
import QnaCtxtUi from 'Views/Cs/QnaCtxtUi';
import QnaRegUi from 'Views/Cs/QnaRegUi';

import GameMnyDpstPopUi from 'Utils/GameMnyDpstPopUi';
import GameMnyDpstDonUi from 'Utils/GameMnyDpstDonUi';
import GameMnyDpstFailUi from 'Utils/GameMnyDpstFailUi';
import GameMnyDpstResult from 'Utils/GameMnyDpstResult';
import GameGuideUi from 'Views/Game/GameGuideUi';

import SsoCallBackKakao from 'Views/Login/SsoCallBackKakao';
import SsoCallBackNaver from 'Views/Login/SsoCallBackNaver';
import SsoCallBackGoogle from 'Views/Login/SsoCallBackGoogle';
import SsoCallBackFacebook from 'Views/Login/SsoCallBackFacebook';
import GameSsoCallBackKakao from 'Views/Login/GameSsoCallBackKakao';
import GameSsoCallBackNaver from 'Views/Login/GameSsoCallBackNaver';
import GameSsoCallBackGoogle from 'Views/Login/GameSsoCallBackGoogle';
import GameSsoCallBackFacebook from 'Views/Login/GameSsoCallBackFacebook';
import { useDispatch} from 'react-redux';
import { LoginInfoStateChng } from 'Stores/LoginInfoReducer';
import { LangSetStateChng } from 'Stores/LangSetReducer';
import { IdntMthdCdStateChng } from 'Stores/IdntMthdCdReducer';
import GameMainLayout from 'Layouts/GameMainLayout';
import CtntCtxtUi from 'Views/Ctnt/CtntCtxtUi';
import GameCtntCtxtUi from 'Views/Ctnt/GameCtntCtxtUi';
import GameCtntPstdLstUi from 'Views/Ctnt/GameCtntPstdLstUi';
import MembGameSvcMnyDpstLstUi from 'Views/MyPage/MembGameSvcMnyDpstLstUi';
import BlckMembUi from 'Views/Login/BlockMembUi';
import GameLnchUi from 'Views/Game/GameLnchUi';
import CsMainUi from 'Views/Cs/CsMainUi';
import FaqLstUi from 'Views/Cs/FaqLstUi';
import MembPagePasswdChngUi from 'Views/MyPage/MembPagePasswdChngUi';
import MembPagePasswdChngInputUi from 'Views/MyPage/MembPagePasswdInputUi';
import MembGameSvcItemOdrLstUi from 'Views/MyPage/MembGameSvcItemOdrLstUi';
import GamePrbbUi from 'Views/Game/GamePrbbUi';
import MembPasswdChngRsltUi from 'Views/Memb/MembPasswdChngRsltUi';
import MgpStore from 'Stores/Store';
import ShopLstUi from 'Views/Shop/ShopLstUi';
import ShopCtntUi from 'Views/Shop/ShopCtntUi';
import TimeGridSelector from 'Utils/GameTimePickerUi';
import LoginBgBLayout from 'Layouts/LoginBgBLayout';
import PrntAthnUi from 'Utils/PrntAthnUi';
import DrmcMembUi from 'Views/Login/DrmcMembUi';
import MembLvdCnclUi from 'Views/Login/MembLvdCnclUi';
import GameCupnUi from 'Views/Game/GameCupnUi';
import GameRegistrationUi from 'Views/Game/GameRegistrationUi';
import MembGameSvcGiftOdrLstUi from 'Views/MyPage/MembGameSvcGiftOdrLstUi';
import PreregisterUi from 'Views/Preregister';
import FtrOnlyLayout from 'Layouts/FtrOnlyLayout';
import GameDownUi from 'Views/Game/GameDownUi';
import CbtMembJoinPage from 'Views/MembJoin/cbtIndex';
import CbtMembJoinFormUi from 'Views/MembJoin/CbtMembJoinFormUi';
import MembEmlUi from 'Views/MyPage/MembEmlUi';

import CbtLoginPage from 'Views/Login/cbtindex';
import CbtMyPage from 'Views/MyPage/cbtmain';
import SsoCallBackApple from 'Views/Login/SsoCallBackApple';
import GameSsoCallBackApple from 'Views/Login/GameSsoCallBackApple';
import MbtiQuiz from 'Views/Content/MbtiQuiz';
import MusicPlayer from 'Components/MusicPlayer';
import GamePackageUi from 'Views/Game/GamePackageUi';
import ApiResultModal from 'Components/ApiResultModal';
import KmcMoCallback from 'Utils/KmcMoCallback';
import CafeEvntUi from 'Views/Cafe';
import CafeMissionUi from 'Views/Cafe/CafeMissionUi';
import AppLogin from 'Views/Cafe/Login/AppLoginUi';
import AppStrtUi from 'Views/Cafe/Login/AppStrtUi';
import AppMembFindIdUi from 'Views/Cafe/Memb/AppMembFindIdUi';
import AppMembPasswdChngRsltUi from 'Views/Cafe/Memb/AppMembPasswdChngRsltUi';
import AppMembPasswdChngUi from 'Views/Cafe/Memb/AppMembPasswdChngUi';
import AppMembFindIdRsltUi from 'Views/Cafe/Memb/AppMembFindIdRsltUi';
import AppOtpAthn from 'Views/Cafe/Login/AppOtpAthn';
import AppBlckMembUi from 'Views/Cafe/Login/AppBlockMembUi';
import AppDrmcMembUi from 'Views/Cafe/Login/AppDrmcMembUi';
import AppMembLvdCnclUi from 'Views/Cafe/Login/AppMembLvdCnclUi';
import AppMembJoinPage from 'Views/Cafe/MembJoin';
import AppMembJoinFormUi from 'Views/Cafe/MembJoin/AppMembJoinFormUi';
import AppMembJoinDoneUi from 'Views/Cafe/MembJoin/AppMembJoinDoneUi';
import AppKmcMoCallback from 'Views/Cafe/AppKmcMoCallback';
import AppLoginLayout from 'Layouts/AppLoginLayout';
import AppMembLvdUi from 'Views/Cafe/MyPage/AppMembLvdUi';
import AppMembPagePasswdChngInputUi from 'Views/Cafe/MyPage/AppMembPagePasswdInputUi';
import AppMembEmlChngUi from 'Views/Cafe/MyPage/AppMembEmlChngUi';
import AppMembEmlChngInputUi from 'Views/Cafe/MyPage/AppMembEmlChngInputUi';
import AppMembPagePasswdChngUi from 'Views/Cafe/MyPage/AppMembPagePasswdChngUi';
import AppNickNameChngInputUi from 'Views/Cafe/MyPage/AppNickNameChngInputUi';
import AppSsoCallBackKakao from 'Views/Cafe/Login/AppSsoCallBackKakao';
import AppSsoCallBackNaver from 'Views/Cafe/Login/AppSsoCallBackNaver';
import AppSsoCallBackGoogle from 'Views/Cafe/Login/AppSsoCallBackGoogle';
import AppSsoCallBackFacebook from 'Views/Cafe/Login/AppSsoCallBackFacebook';
import AppSsoCallBackApple from 'Views/Cafe/Login/AppSsoCallBackApple';
import CommuWriteUi from 'Views/Commu/CommuWrite';
import CommuCtntPstdLstUi from 'Views/Commu/CommuCtntPstdLstUi';
import CommuCtntCtxtUi from "Views/Commu/CommuCtntCtxtUi";
import PreregisterGoUi from 'Views/Event/PreregisterGoUi';
import PageGuard from 'Utils/PageGuard';
import MembIdntMthdReAthnUi from 'Views/MyPage/MembIdntMthdReAthnUi';
import MembIngameIdntMthdChngUi from 'Views/MyPage/MembIngameIdntMthdChngUi';
import MembIngameIdntMthdSussUi from 'Views/MyPage/MembIngameIdntMthdSussUi';
import AppMembIdntMthdChngUi from 'Views/Cafe/MyPage/AppMembIdntMthdChngUi';
import AppDownBridgeUi from 'Views/Cafe/Login/AppDownBridgeUi';

declare global {
  interface Window {
    Naver:any;
    GX_pay:any;
    OpenrReplaceFunc:any;
  }
}

// --- 동적 파비콘 훅 ---
function useDynamicFavicon() {
  const location = useLocation();
  useFaviconEffect(() => {
    const params = new URLSearchParams(location.search);
    const gameSvcCd = (params.get("gameSvcCd") || "bbo").toLowerCase();
    const faviconUrl = `/images/favicon/${gameSvcCd}_favicon.png`;
    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = faviconUrl;
  }, [location.search]);
}

function App() {
  useDynamicFavicon();
  const [loginInfo,setLoginInfo] =useState<any>();
  const [globalErrorOpen, setGlobalErrorOpen] = useState(false);
  const [globalErrorMessage, setGlobalErrorMessage] = useState("");
  
  // 도메인 리다이렉트: bearbrickheroes.gameking.com → bearbrickheroes.onuniverse.io
  useEffect(() => {
    // const currentHost = window.location.hostname;
    // if (currentHost === 'bearbrickheroes.gameking.com') {
    //   const pathname = window.location.pathname;
    //   const search = window.location.search;
    //   const hash = window.location.hash;
    //   const redirectUrl = `https://bearbrickheroes.onuniverse.io${pathname}${search}${hash}`;
    //   window.location.href = redirectUrl;
    // }
  }, []);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation(); // 라우트 변경 감지

// 도메인 기반 자동 라우팅 (환경변수로 온오프)
useEffect(() => {
  const ENABLE_SUBDOMAIN_REDIRECT = process.env.REACT_APP_ENABLE_SUBDOMAIN_REDIRECT === 'true';
  if (!ENABLE_SUBDOMAIN_REDIRECT) return;

  const hostname = window.location.hostname;
  const domainGameMap = getDomainGameMap();
  const gameSvcCd = domainGameMap[hostname];
  
  // 서브도메인에서 메인 페이지 접속 시 해당 게임 페이지로 자동 이동
  if (gameSvcCd && location.pathname === '/') {
    navigate(`/GamePage?gameSvcCd=${gameSvcCd}`, { replace: true });
  }
}, [location.pathname]);

useEffect(()=>{
  // AbortController로 이전 요청 취소
  const abortController = new AbortController();
  
  // 페이지 이동 시마다 유지보수 상태 체크
  IsMntnInqApi("mgp")
  .then((Resp) => {
     // MGP 본체 점검 확인 (본체 점검 시 모든 페이지 차단)
            const mgpMntnInfo = Resp.apiBody?.find((item: any) => item.gameSvcCd === "MGP");
            
            if(mgpMntnInfo && mgpMntnInfo.isMntn === "Y") {
                console.log("MGP 점검 중 - 점검 페이지로 이동");
                return navigate("/mntn?gameSvcCd=MGP", { replace: true, state: { mntnData: Resp.apiBody } });
            }
    // 유지보수 모드인 경우 처리 로직 추가 가능
  })
  .catch((error) => {
    if (error.name !== 'AbortError') {
      console.error('IsMntnInqApi error:', error);
    }
  });

  // 페이지 이동 시마다 로그인 상태 체크
  IsLoginApi()
  .then((Resp) => {
    if (abortController.signal.aborted) return;
    if(Resp != null ){
      dispatch(LoginInfoStateChng(Resp));
      const idntMthdCd = String(Resp?.apiBody?.idntMthdCd || "").toUpperCase();
      if (idntMthdCd === "NA" || idntMthdCd === "EML" || idntMthdCd === "MBP") {
        dispatch(IdntMthdCdStateChng(idntMthdCd));
      }
    }
    if(Resp.apiBody.prfLang != null) {
      dispatch(LangSetStateChng(Resp.apiBody.prfLang));  
    }
  })
  .catch((error) => {
    if (error.name !== 'AbortError') {
      console.error('IsLoginApi error:', error);
    }
  });
  
  // cleanup: 컴포넌트 언마운트 시 요청 취소
  return () => {
    abortController.abort();
  };
}, [location.pathname]); // location.pathname이 변경될 때마다 실행

useEffect(() => {
  const handler = (event: Event) => {
    const customEvent = event as CustomEvent<{ message?: string }>;
    const message = customEvent.detail?.message;
    if (!message) return;
    setGlobalErrorMessage(message);
    setGlobalErrorOpen(true);
  };

  window.addEventListener("app:api-error", handler as EventListener);
  return () => {
    window.removeEventListener("app:api-error", handler as EventListener);
  };
}, []);

useEffect(() => {
  const OpenrReplaceFunc =(destination:string) => {
    navigate(destination);
  }
  window.OpenrReplaceFunc = OpenrReplaceFunc;
}, []);

  const LangSet = useSelector(
    (state:{LangSetState:{Lang:string}}) => state.LangSetState.Lang
  );
  const isPopupWindow = typeof window !== 'undefined' && !!window.opener && !window.opener.closed;
  const isPopupRoute = /^\/(EmlAthnPop|MbpAthnCallback|GameMnyDpstPop)(\/|$)/i.test(location.pathname);
  const isConnectRoute = /^\/Connect(\/|$)/i.test(location.pathname);
  const isPreReservationRoute = /^\/PreReservation_GrandOpen(\/|$)/i.test(location.pathname);
  const shouldShowMusicPlayer = !isPopupWindow && !isPopupRoute && !isConnectRoute && !isPreReservationRoute;
  return (
        <>
          <RouteChngTracker />
          <ApiResultModal
            open={globalErrorOpen}
            message={globalErrorMessage}
            onClose={() => setGlobalErrorOpen(false)}
          />
          {shouldShowMusicPlayer && <MusicPlayer />}
          <Routes>
              <Route element={<MainLayout />} >
              <Route path='/'  element={<MainPage />}></Route>
              <Route path='/PrntAthn' element={<PrntAthnUi/>}></Route>
              <Route element={<PrivateRoute />}>
              </Route>
            </Route>
            {/* Connect */}
            <Route element={<AppLoginLayout />}>
              <Route path='/Connect/AppStrt' element={<AppStrtUi />}></Route>
              <Route path='/Connect/Login'    element={<AppLogin/>}></Route>
              <Route path='/Connect/MembFindId'  element={<AppMembFindIdUi />}></Route>
              <Route path='/Connect/MembFindId/List'  element={<AppMembFindIdRsltUi />}></Route>
              <Route path='/Connect/MembFindPw'  element={<AppMembPasswdChngUi />}></Route>
              <Route path='/Connect/MembFindPw/FindPwInput' element={<AppMembPasswdChngRsltUi/>}/>
              <Route path='/Connect/BlckMemb' element={<AppBlckMembUi/>}></Route>
              <Route path='/Connect/DrmcMemb' element={<AppDrmcMembUi/>}></Route>
              <Route path='/Connect/MembLvdCncl' element={<AppMembLvdCnclUi/>}></Route>
              <Route path='/Connect/SsoMembJoin'   element={<AppMembJoinPage />}></Route>
              <Route path='/Connect/MembJoin'   element={<AppMembJoinFormUi />}></Route>
              <Route path='/Connect/MembJoinDone'  element={<AppMembJoinDoneUi />}></Route>
              <Route path='/Connect/OtpAthn'    element={<AppOtpAthn/>}></Route>
              <Route path='/KmcMoCallback'   element={<KmcMoCallback/>}></Route>
              <Route path='/Connect/MyPage/EmlChng' element={<AppMembEmlChngUi/>}/>
              <Route path='/Connect/MyPage/EmlChngInput'element={<AppMembEmlChngInputUi />} />
              <Route path='/Connect/MyPage/PasswdChng' element={<AppMembPagePasswdChngUi />} />
              <Route path='/Connect/MyPage/PasswdChngInput' element={<AppMembPagePasswdChngInputUi />} />
              <Route path='/Connect/MyPage/NickNameChngInput' element={<AppNickNameChngInputUi/>}/>
              <Route path='/Connect/MyPage/MembLvd' element={<AppMembLvdUi/>}/>
              <Route path='/Connect/MyPage/IdntMthdChng' element={<AppMembIdntMthdChngUi/>}/>
              <Route path='/Connect/login/app_sso_callback_kakao' element={<AppSsoCallBackKakao />}></Route>
              <Route path='/Connect/login/app_sso_callback_naver' element={<AppSsoCallBackNaver />}></Route>
              <Route path='/Connect/login/app_sso_callback_google' element={<AppSsoCallBackGoogle />}></Route>
              <Route path='/Connect/login/app_sso_callback_Facebook' element={<AppSsoCallBackFacebook />}></Route>
              <Route path='/Connect/login/app_sso_callback_apple' element={<AppSsoCallBackApple />}></Route>
              <Route path='/Connect/login/app_down_bridge' element={<AppDownBridgeUi />}></Route>
            </Route>
            {/* Connect End */}
            <Route element={<LoginLayout />}>
              <Route path='/gameLnchStrt' element={<GameLnchStrtUi />}></Route>
              <Route path='/MembFindId'  element={<MembFindIdUi />}></Route>
              <Route path='/MembFindId/List'  element={<MembFindIdRsltUi />}></Route>
              <Route path='/MembFindPw'  element={<MembPasswdChngUi />}></Route>
              <Route path='/MembFindPw/FindPwInput' element={<MembPasswdChngRsltUi/>}/>
              <Route path='/BlckMemb' element={<BlckMembUi/>}></Route>
              <Route path='/DrmcMemb' element={<DrmcMembUi/>}></Route>
              <Route path='/MembLvdCncl' element={<MembLvdCnclUi/>}></Route>
              <Route path='/Connect/Login'    element={<CbtLoginPage/>}></Route>
              <Route path='/Login'    element={<CbtLoginPage/>}></Route>
              <Route path='/SsoMembJoin'   element={<MembJoinPage />}></Route>
              <Route path='/MembJoin'   element={<CbtMembJoinFormUi />}></Route>
              <Route path='/MembJoin/MembJoinDone'  element={<MembJoinDoneUi />}></Route>
              <Route path='/OtpAthn'    element={<OtpAthn/>}></Route>
              <Route path='/GameLogin'    element={<GameLogin/>}></Route>
            </Route>
            < Route element={<PopLayout />}>
              <Route path='/EmlAthnPop'  element={<EmlAthnPopUi />}></Route>
              <Route path='/MbpAthnCallback' element={<MbpAthnCallback />}></Route>
            </Route>
            <Route element={<PrivateRoute />}>
              < Route element={<LeftMenuLayout />}>
                <Route path='/MyPage'  element={<MyPage/>}></Route>
                <Route path='/MyPage/OtpReg' element={<MembOtpRegUi/>}/>
                <Route path='/MyPage/OtpRegInput' element={<MembOtpRegInputUi/>}/>
                <Route path='/MyPage/IdntMthdChng' element={<MembIdntMthdChngUi/>}/>
                <Route path='/MyPage/IngameIdntMthdChng' element={<MembIngameIdntMthdChngUi/>}/>
                <Route path='/MyPage/IngameIdntMthdSuss' element={<MembIngameIdntMthdSussUi/>}/>
                <Route path='/MyPage/IdntMthdReAthn' element={<MembIdntMthdReAthnUi/>}/>
                <Route path='/MyPage/EmlChng' element={<MembEmlChngUi/>}/>
                <Route path='/MyPage/Eml' element={<MembEmlUi/>}/> 
                <Route path='/MyPage/EmlChngInput'element={<MembEmlChngInputUi />} />
                <Route path='/Mypage/PasswdChng' element={<MembPagePasswdChngUi />} />
                <Route path='/Mypage/PasswdChngInput' element={<MembPagePasswdChngInputUi />} />
                <Route path='/MyPage/MembLvd' element={<MembLvdUi/>}/>
                <Route path='/MyPage/GameSvcMnyDpstLst' element={<MembGameSvcMnyDpstLstUi/>}></Route>
                <Route path='/MyPage/GameSvcItemOdrLst' element={<MembGameSvcItemOdrLstUi/>}></Route>
                <Route path='/MyPage/GameSvcGiftOdrLst' element={<MembGameSvcGiftOdrLstUi/>}></Route>
                <Route path='/MyPage/GameSvcRelLst' element={<MembGameSvcRelUi/>}></Route>
                <Route path='/MyPage/NtfyMsgLst' element={<MembNtfyMsgLstUi/>}></Route>
                <Route path='/MyPage/QnaLst' element={<QnaLstUi/>} />
                <Route path='/MyPage/QnaCtxt' element={<QnaCtxtUi/>} />
                <Route path='/MyPage/QnaWrite' element={<QnaRegUi/>} />
              </Route>
            </Route>
            <Route element={<GameMainLayout/>} >
              <Route path='/Connect/ConnectMission' element={
                <PageGuard tstKindCd='WEB'>
                  <CafeMissionUi/>
                </PageGuard>
              }></Route>
              <Route path='/Connect/ConnectEvent' element={
                <PageGuard tstKindCd='WEB'>
                  <CafeEvntUi/>
                </PageGuard>
                }></Route>
              <Route path='Landing' element={<GamePackageUi />}></Route>
              <Route path='/Cs/Main'  element={<CsMainUi />} />
              <Route path='/Cs/FaqLst' element={<FaqLstUi/>} />
              <Route path='/Ctnt/CtntCtxt' element={<CtntCtxtUi/>}></Route>
              <Route path='/Ctnt/CtntLst' element={<CtntPstdLstUi/>}></Route>
              <Route path='/GamePage' element={<GamePageMainUi />}></Route>
              <Route
                path='/GamePage/ShopLst'
                element={
                    <ShopLstUi />
                }
              ></Route>
              <Route path='/GamePage/ShopCtnt' element={<ShopCtntUi/>}></Route>
              <Route path='/GamePage/Ctnt/CtntCtxt' element={<GameCtntCtxtUi/>}></Route>
              <Route path='/GamePage/Ctnt/CtntLst' element={<GameCtntPstdLstUi/>}></Route>
              <Route path='/GamePage/GameGuide' element={<GameGuideUi/>}></Route>
              <Route path='/GamePage/GamePrbb' element={<GamePrbbUi/>}></Route>
              <Route path='/GamePage/GameCupn' element={<GameCupnUi/>}></Route>
              <Route path='/GamePage/GameRegistration' element={<GameRegistrationUi />}></Route>
              <Route path='/GamePage/DownLoad' element={<GameDownUi />}></Route>
              <Route path='/Community/Write' element={<CommuWriteUi />}></Route>
              <Route path='/Community/CtntCtxt' element={<CommuCtntCtxtUi />}></Route>
              <Route path='/Community/Lst' element={<CommuCtntPstdLstUi />}></Route>
              <Route path='/Trms' element={<TrmsCtxtUi />}></Route>
              <Route
                path='/PreReservation_GrandOpen'
                element={
                  //  <PageGuard tstKindCd='WEB'>
                  //     <PreregisterGoUi />
                  //  </PageGuard>
                  <PreregisterGoUi />
                }
              ></Route>
            </Route>
            <Route path='/login/sso_callback_kakao' element={<SsoCallBackKakao />}></Route>
            <Route path='/login/sso_callback_naver' element={<SsoCallBackNaver />}></Route>
            <Route path='/login/sso_callback_google' element={<SsoCallBackGoogle />}></Route>
            <Route path='/login/sso_callback_Facebook' element={<SsoCallBackFacebook />}></Route>
            <Route path='/login/sso_callback_apple' element={<SsoCallBackApple />}></Route>

            <Route path='/login/game_sso_callback_kakao' element={<GameSsoCallBackKakao />}></Route>
            <Route path='/login/game_sso_callback_naver' element={<GameSsoCallBackNaver />}></Route>
            <Route path='/login/game_sso_callback_google' element={<GameSsoCallBackGoogle />}></Route>
            <Route path='/login/game_sso_callback_Facebook' element={<GameSsoCallBackFacebook />}></Route>
            <Route path='/login/game_sso_callback_apple' element={<GameSsoCallBackApple />}></Route>
            <Route element={<FtrOnlyLayout/>} >
              {/* <Route path='/'  element={<MainPage />}></Route> */}
              <Route path='/bb4me'  element={<MbtiQuiz />} />
            </Route>
            {/* <Route path='/GameMnyDpstPop' element={<GameMnyDpstPopUi />}></Route> */}
            <Route path='/GameMnyDpstDone' element={<GameMnyDpstDonUi />}></Route>
            <Route path='/GameMnyDpstFail' element={<GameMnyDpstFailUi />}></Route>
            <Route path='/GameMnyDpstResult' element={<GameMnyDpstResult />}></Route>
            <Route path='/mntn' element={<CommMntnUi />}></Route>
            <Route path='/*' element={<CommErrorUi />}></Route>
            <Route path='/GameLnchPage' element={<GameLnchUi />}></Route>
          </Routes>
        </>
  );
}

export default App;


